import { Behavior } from '../Behavior';
import { TaskStatus } from '../TaskStatus';
/**
 * 当随机概率高于successProbability概率时返回成功。
 * 否则它将返回失败。
 * successProbability应该在0和1之间
 */
export class RandomProbability extends Behavior {
    constructor(successProbability) {
        super();
        this.discriminator = "IConditional";
        this._successProbability = successProbability;
    }
    update(_context) {
        if (Math.random() > this._successProbability)
            return TaskStatus.Success;
        return TaskStatus.Failure;
    }
}
//# sourceMappingURL=RandomProbability.js.map